import React from 'react';
import PropTypes from 'prop-types';
import { trackAction } from '@/utils';

const targetEnum = ['_self', '_blank', '_parent', '_top'];

const TrackingLink = ({ trackInfoMelidata, className, href, children, target }) => {
  const trackData = () => {
    trackAction({
      melidata: trackInfoMelidata,
    });
  };

  return (
    <a className={className || ''} href={href || ''} target={target} onClick={trackData}>
      { children }
    </a>
  );
};

TrackingLink.propTypes = {
  trackInfo: PropTypes.shape({
    hitType: PropTypes.string,
    eventCategory: PropTypes.string,
    eventAction: PropTypes.string,
    eventLabel: PropTypes.string,
    eventValue: PropTypes.string,
  }),
  trackInfoMelidata: PropTypes.shape({
    path: PropTypes.string,
    type: PropTypes.string,
  }),
  children: PropTypes.node,
  className: PropTypes.string,
  href: PropTypes.string,
  target: PropTypes.oneOf(targetEnum),
};

TrackingLink.defaultProps = {
  children: null,
  className: null,
  href: null,
  trackInfoMelidata: null,
  target: '_self',
};

export default TrackingLink;
